import React from 'react'
import { NavLink } from 'react-router-dom'

export const DashboardPages = props => {
    const { data, loading } = props

    return (
        <div className="dashboard-table">
            <div
                className="table-column"
                style={{
                    color: '#338CE4',
                }}
            >
                <div className="header">Recently edited pages</div>
                <div className="view-all">
                    <NavLink to="/pages" activeClassName="active">
                        View All
                    </NavLink>
                </div>
            </div>
            {loading ? (
                <div className="table-column">Pages Loading...</div>
            ) : (
                <div>
                    {!data || data <= 1 ? (
                        <div className="table-column">No results found</div>
                    ) : (
                        <div>
                            <div
                                className="table-column"
                                style={{
                                    color: '#212529',
                                }}
                            >
                                <div style={{ width: '50%' }}>Name</div>
                                <div style={{ width: '25%' }}>Modified By</div>
                                <div style={{ width: '25%' }}>Locale</div>
                            </div>
                            {data.map(pages => (
                                <div key={pages.id} className="table-column">
                                    <div style={{ color: '#338CE4', width: '50%' }}>
                                        <NavLink
                                            to={`/content/edit/page/${pages.id}`}
                                            activeClassName="active"
                                        >
                                            {pages.name}
                                        </NavLink>
                                    </div>
                                    <div style={{ width: '25%' }}>
                                        {`${pages.modifiedBy?.firstName} 
                                        ${pages.modifiedBy?.lastName}`}
                                    </div>
                                    <div style={{ width: '25%' }}>{pages.locale}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
